module.exports = __webpack_public_path__ + "static/media/eyeLookUpLeft.c78aee3c.obj";